<template>
  <vs-button
    v-if="isEnabled"
    :disabled="isDisabled"
    class="my-1 mx-2"
    size="small"
    color="#00a4e4"
    type="filled"
    @click="handleClick"
  >
    {{ label }}
  </vs-button>
</template>

<script>
export default {
  props: {
    label: String,
    paymentType: String,
    isEnabled: Boolean,
    isDisabled: Boolean,
    withdrawdata: Object
  },
  methods: {
    handleClick () {
      this.$emit('generate-token', this.withdrawdata.wd_id, this.paymentType)
      this.$emit('verify-payment', this.withdrawdata.bank_code, this.withdrawdata.bank_number, this.withdrawdata.amount, this.paymentType)
    }
  }
}
</script>